import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { getAssessmentBEIQuestion } from '../../../../../../../utils/api_service/Behavioral';
import { JobDescription } from '../../../../../../../utils/types/JobOpenings';
import { BEIAttributesSidebar, BEIQuestionsContent } from './Components';

interface Props {
  jobDescription?: JobDescription;
  assessmentID: string;
}

export const BEIQuestions: React.FC<Props> = ({ jobDescription, assessmentID }) => {
  const [selectedAttributes, setSelectedAttributes] = useState<string[]>([]);
  const [shouldGenerateQuestions, setShouldGenerateQuestions] = useState(false);
  const [questions, setQuestions] = useState<any[]>([]);
  const [editingTimeLimit, setEditingTimeLimit] = useState<number>(300);

  const handleGenerateQuestions = (attributes: string[]) => {
    setSelectedAttributes(attributes);
    setShouldGenerateQuestions(true);
  };

  useEffect(() => {
    const fetchBEIQuestions = async () => {
      try {
        const response = await getAssessmentBEIQuestion(assessmentID);
        if (response.ok) {
          const data = await response.json();
          const formatted = data.questions.map((q: any, index: number) => ({
            id: index + 1,
            question: q.question,
            attribute: q.attribute,
          }));
          setEditingTimeLimit(data.timeLimit);
          const attrList = formatted.map((q: any) => q.attribute);
          setSelectedAttributes(attrList);
          setQuestions(formatted);
        }
      } catch (e) {
        console.error(e);
      }
    };

    fetchBEIQuestions();
  }, [assessmentID]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', lg: 'row' },
        gap: 2,
        minHeight: { xs: '70vh', lg: '80vh' },
        height: '100%',
      }}
    >
      <BEIAttributesSidebar
        jobDescription={jobDescription}
        onGenerateQuestions={handleGenerateQuestions}
      />
      {/* Scrollable content area */}
      <Box sx={{ minWidth: 0, flex: 1, overflowY: 'auto' }}>
        <BEIQuestionsContent
          assessmentID={assessmentID}
          jobDescription={jobDescription}
          selectedAttributes={selectedAttributes}
          shouldGenerate={shouldGenerateQuestions}
          questions={questions}
          setQuestions={setQuestions}
          editingTimeLimit={editingTimeLimit}
          setEditingTimeLimit={setEditingTimeLimit}
        />
      </Box>
    </Box>
  );
};
